"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var navigation_tabs_styled_components_1 = require("./navigation-tabs.styled.components");
var NavigationTabs = function (_a) {
    var tabs = _a.tabs, onChange = _a.onChange, children = _a.children, alternateSlot = _a.alternateSlot;
    return (react_1.default.createElement(navigation_tabs_styled_components_1.TabWrapper, { className: "tab-wrapper" },
        react_1.default.createElement(navigation_tabs_styled_components_1.NavigationList, { className: "tab-navigation" },
            tabs.map(function (tab, key) { return (react_1.default.createElement(navigation_tabs_styled_components_1.NavigationListItem, { role: "presentation", key: key, active: tab.activeTab, onClick: function () { return onChange(key); }, "data-test-id": tab.testID }, tab.tabText)); }),
            alternateSlot && react_1.default.createElement(navigation_tabs_styled_components_1.AlternateSlot, null, alternateSlot)),
        react_1.default.createElement(navigation_tabs_styled_components_1.ShowContent, { className: "tab-content" }, children)));
};
exports.default = NavigationTabs;
//# sourceMappingURL=navigation-tabs.component.js.map